<template>
  <div id="bto-design-customize-select" title="おすすめ選択">
    <div class="select-change">
      <button
        class="select-alls"
        @click="switchSelectedArrangeType('select-alls')"
      >
        すべて選択
      </button>
      <button
        class="select-reverse"
        @click="switchSelectedArrangeType('select-reverse')"
      >
        選択反転
      </button>
      <button
        class="select-clear"
        @click="switchSelectedArrangeType('select-clear')"
      >
        全て解除
      </button>
    </div>
    <div class="select-area">
      <img
        class="select-area-title"
        :src="getTitleImageSelectedPosition()"
        alt="おすすめ選択"
      />
      <button
        v-for="(code, key) in recommendedSelect"
        :key="key"
        :class="'select-' + code"
        v-show="!('x' == key || 'y' == key)"
        @click="switchSelectedArrangeType(key)"
      >
        {{ code == "mp" ? "メイン彫刻" : code }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "DesignCustomizeSelect",

  props: {
    recommendedSelect: {
      type: Object,
    },
    assetsRoute: {
      type: String,
    },
  },

  methods: {
    /**
     * .select-area-titleの画像URLを返す
     * @return {[String]} [URL]
     */
    getTitleImageSelectedPosition() {
      return (
        process.env.VUE_APP_LIT_REST_ROUTE +
        "/img/lithos_philia/common/bps_img_osusume.png"
      );
    },

    /**
     * 選択コードを受け取って、vuexのselectedArrangeTypeを更新する
     * メイン彫刻の場合はvuexのselectedLabelCodeも更新する
     * @type {String}
     */
    switchSelectedArrangeType(code) {
      if ("m" === code) {
        this.updateSelectedLabelCode("option_mp");
      } else if ("option_mp" === this.$store.state.selectedLabelCode) {
        this.updateSelectedLabelCode("all");
      }

      this.updateselectedArrangeType(code);
    },

    ...mapMutations(["updateselectedArrangeType", "updateSelectedLabelCode"]),
  },
};
</script>

<style scoped lang="stylus">
@import url('https://fonts.googleapis.com/css2?family=Londrina+Solid:wght@300&display=swap')

#bto-design-customize-select .select-change
  grid-template-areas: "all reverse clear"
#bto-design-customize-select .select-area
  grid-template-areas: ". mp mp mp ." "a b c d e"

@screen lg

  #bto-design-customize-select .select-area
    grid-template-areas: "mp a b c d e"


.select-alls
  grid-area: all
.select-reverse
  grid-area: reverse

.select-alls,
.select-reverse
  color: #694c37;
  --tw-gradient-from: #f7e5e4
.select-clear
  grid-area: clear
  color: #694c37;
  --tw-gradient-from: #dbdbdb
.select-mp
  grid-area: mp
  color: #694c37;
  --tw-gradient-from: #e9e3d8
.select-a
  grid-area: a
  color: #e57782
  --tw-gradient-from: #f6d2db
.select-b
  grid-area: b
  color: #a09cc6
  --tw-gradient-from: #dadae9
.select-c
  grid-area: c
  color: #e6914b
  --tw-gradient-from: #f5ddcd
.select-d
  grid-area: d
  color: #366fa3
  --tw-gradient-from: #cedae8
.select-e
  grid-area: e
  color: #49b5ad
  --tw-gradient-from: #c0e9ea
.select-area-title
  grid-area: mp

@css {
	#bto-design-customize-select {
    background-color: #efebe3;
    @apply px-2 py-4 text-left mb-4
  }

  #bto-design-customize-select .select-change,
  #bto-design-customize-select .select-area {
    @apply grid gap-2
  }
  #bto-design-customize-select button {
    @apply border-solid border text-center mb-2 bg-white focus:outline-none
  }

  .select-alls,
  .select-reverse,
  .select-clear {
    @apply flex-1
  }

  .select-mp {

  }

  .select-alls,
  .select-reverse,
  .select-clear,
  .select-mp,
  .select-a,
  .select-b,
  .select-c,
  .select-d,
  .select-e {
    border-color: #c4b7ab;
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(0, 0, 0, 0));
    @apply bg-gradient-to-t to-white p-1 rounded-sm text-base font-bold mx-1 shadow
  }
  .select-a,
  .select-b,
  .select-c,
  .select-d,
  .select-e {
    font-family: 'Londrina Solid', cursive;
    text-transform: uppercase;
    @apply py-0 text-3xl
  }
  .select-area-title {
    @apply my-1 mx-auto lg:ml-4 inline-block
  }
}
</style>
